import { render, staticRenderFns } from "./claim-view.vue?vue&type=template&id=420ea21a&scoped=true&"
import script from "./claim-view.vue?vue&type=script&lang=js&"
export * from "./claim-view.vue?vue&type=script&lang=js&"
import style0 from "./claim-view.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./claim-view.vue?vue&type=style&index=1&id=420ea21a&scoped=true&lang=css&"
import style2 from "./claim-view.vue?vue&type=style&index=2&lang=css&"
import style3 from "./claim-view.vue?vue&type=style&index=3&id=420ea21a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ea21a",
  null
  
)

export default component.exports